// Header.js
import React from "react";

const Header = () => {
  return (
    <header className="bg-gray-700 text-white py-4">
      <div className="container mx-auto flex justify-start items-center px-2">
        <div className="text-xl font-bold">React30</div>
      </div>
    </header>
  );
};

export default Header;
